import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import pt from "./pt.json";
import es from "./es.json";

export const LANGUAGES = [
  { code: "en", label: "English",    flag: "🇺🇸" },
  { code: "pt", label: "Português",  flag: "🇧🇷" },
  { code: "es", label: "Español",    flag: "🇪🇸" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      pt: { translation: pt },
      es: { translation: es },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "pt", "es"],
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "ufo_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    returnObjects: true,
  });

// Keep <html lang> in sync so browsers / a11y tools pick it up
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") document.documentElement.lang = lng;
});
if (typeof document !== "undefined") document.documentElement.lang = i18n.resolvedLanguage || "en";

export default i18n;
